"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jquery_1 = __importDefault(require("jquery"));
jquery_1["default"](function () {
    /* Interface to set permissions from the explorer / editor */
    // eslint-disable-next-line func-names
    jquery_1["default"]('button.action-set-privacy').on('click', function () {
        // eslint-disable-next-line no-undef, new-cap
        ModalWorkflow({
            url: this.getAttribute('data-url'),
            onload: {
                set_privacy: function (modal) {
                    // eslint-disable-next-line func-names
                    jquery_1["default"]('form', modal.body).on('submit', function () {
                        modal.postForm(this.action, jquery_1["default"](this).serialize());
                        return false;
                    });
                    var restrictionTypePasswordField = jquery_1["default"]("input[name='restriction_type'][value='password']", modal.body);
                    var restrictionTypeGroupsField = jquery_1["default"]("input[name='restriction_type'][value='groups']", modal.body);
                    var passwordField = jquery_1["default"]('.password-field', modal.body);
                    var groupsFields = jquery_1["default"]('#groups-fields', modal.body);
                    function refreshFormFields() {
                        if (restrictionTypePasswordField.is(':checked')) {
                            passwordField.show();
                            groupsFields.hide();
                        }
                        else if (restrictionTypeGroupsField.is(':checked')) {
                            passwordField.hide();
                            groupsFields.show();
                        }
                        else {
                            passwordField.hide();
                            groupsFields.hide();
                        }
                    }
                    refreshFormFields();
                    jquery_1["default"]("input[name='restriction_type']", modal.body).on('change', refreshFormFields);
                },
                set_privacy_done: function (modal, jsonData) {
                    modal.respond('setPermission', jsonData.is_public);
                    modal.close();
                }
            },
            responses: {
                setPermission: function (isPublic) {
                    if (isPublic) {
                        jquery_1["default"]('.privacy-indicator').removeClass('private').addClass('public');
                        jquery_1["default"]('.privacy-indicator-tag').addClass('u-hidden').attr('aria-hidden', 'true');
                    }
                    else {
                        jquery_1["default"]('.privacy-indicator').removeClass('public').addClass('private');
                        jquery_1["default"]('.privacy-indicator-tag').removeClass('u-hidden').attr('aria-hidden', 'false');
                    }
                }
            }
        });
        return false;
    });
});
